const SewerageType = {
  SANITARNA: { label: 'Sanitarna', value: 0 },
  OBORINSKA: { label: 'Oborinska', value: 1 },
  MJESOVITA: { label: 'Mješovita', value: 2 },
  SLIVNICI: { label: 'Slivnici', value: 3 },
  LINIJSKERESETKE: { label: 'Linijske rešetke', value: 4 },
};

export default SewerageType;
